import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITreeViewCheckProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import checkBoxStylesheet, {
    getCheckBoxMeasures,
    getCheckBoxColors,
    getCheckBoxType,
    useStyles
} from "../../../checkBox/stylesheet";
import {
    useTreeViewContext
} from "../../context";
import {
    Check as CheckIcon,
    Minus as MinusIcon
} from "lucide-react-native";

const TreeViewCheck: FC<ITreeViewCheckProps> = ({
    isDisabled = false,
    state
}) => {
    const {
        customTheme
    } = useTreeViewContext();

    const {
        shapeConfigs,
        shadowAlpha,
        elevations,
        iconSizes,
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isSelected = state !== "unchecked";

    const currentType = getCheckBoxType({
        type: "primary",
        colors
    });

    const currentMeasures = getCheckBoxMeasures({
        iconSizes,
        radiuses,
        borders,
        spaces
    });

    const currentColors = getCheckBoxColors({
        isError: false,
        currentType,
        isDisabled,
        isSelected,
        colors
    });

    const {
        box: boxDynamicStyle
    } = useStyles({
        currentMeasures,
        currentColors,
        shapeConfigs,
        shadowAlpha,
        elevations,
        isDisabled,
        colors
    });

    const renderGlyph = () => {
        if(state === "unchecked") {
            return null;
        }

        const Glyph = state === "indeterminate" ? MinusIcon : CheckIcon;

        return <Glyph
            strokeWidth={shapeConfigs.glyphStrokeWidth}
            color={currentColors.glyphColor}
            size={currentMeasures.glyphSize}
        />;
    };

    return <View
        style={[
            checkBoxStylesheet.box,
            boxDynamicStyle
        ]}
        aria-hidden={true}
    >
        {renderGlyph()}
    </View>;
};
export default TreeViewCheck;
